import { createContext, useContext, useEffect, useState } from "react";
import { ServerContext } from "./ServerContext";

export const ChangeLogContext = createContext(null);

const DASH = 1;            // ou dinâmico
const CHECK_INTERVAL = 60000; // 1 minuto
const STORAGE_KEY = `changelog_last_seen_id_dash_${DASH}`;

export function ChangeLogProvider({ children }) {
  const { servidor } = useContext(ServerContext);

  const [hasNewChangeLog, setHasNewChangeLog] = useState(false);
  const [latestChangeLog, setLatestChangeLog] = useState(null);
  const [lastSeenId, setLastSeenId] = useState(null);

  // Carrega o último ID visto inicialmente
  useEffect(() => {
    if (!servidor) return;

    const storedId = localStorage.getItem(STORAGE_KEY);
    if (storedId) {
      setLastSeenId(Number(storedId));
      return; // já temos referência, não precisa chamar a API agora
    }

    // 2) Se não tiver cache, busca o último da API e considera como "visto"
    fetch(`${servidor}/api/changelogs/${DASH}`)
      .then((r) => r.json())
      .then((data) => {
        if (data?.length) {
          setLastSeenId(data[0].id_change_log);
          localStorage.setItem(STORAGE_KEY, String(data[0].id_change_log));
        }
      })
      .catch(() => {});
  }, [servidor]);

  // Verificação periódica
  useEffect(() => {
    if (!servidor || !lastSeenId) return;

    const check = async () => {
      try {
        /*const resp = await fetch(
          `${servidor}/api/changelogs/latest/${DASH}`
        );
        if (!resp.ok) return;

        const data = await resp.json();
        if (!data) return;

        if (data.id_change_log !== lastSeenId) {
          setHasNewChangeLog(true);
          setLatestChangeLog(data);
        }*/
      } catch {
        /* silencioso */
      }
    };

    const interval = setInterval(check, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, [servidor, lastSeenId]);

  // Marcar como "visto"
  function markAsSeen() {
    if (latestChangeLog) {
      setLastSeenId(latestChangeLog.id_change_log);
      localStorage.setItem(STORAGE_KEY, String(latestChangeLog.id_change_log));
    }
    setHasNewChangeLog(false);
  }

  return (
    <ChangeLogContext.Provider
      value={{
        hasNewChangeLog,
        latestChangeLog,
        markAsSeen,
      }}
    >
      {children}
    </ChangeLogContext.Provider>
  );
}
